import React, { useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd';
import { Spinner } from '../../../components/Spinner';
import { useAuthorRelationshipSummary } from '../../../core/modules/book/hooks/useAuthorRelationshipSummary';
import AiSummaryBar from '../AiSummaryBar';
import { renderExplanation } from '../renderAiMarkup';

const { Text } = Typography;

const ACCENT = '#3b2984';

interface IAuthorRelationshipSummaryProps {
  authorName: string;
  // The deals read's fetched_at; a Refresh changes it and re-summarizes while open.
  dataVersion: string;
}

const AuthorRelationshipSummary: React.FC<IAuthorRelationshipSummaryProps> = ({
  authorName,
  dataVersion
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { data, isLoading, isError, refetch } = useAuthorRelationshipSummary(
    authorName,
    isOpen,
    dataVersion
  );

  return (
    <AiSummaryBar
      title='Summarize author relationship'
      isOpen={isOpen}
      onToggle={() => setIsOpen((open) => !open)}
    >
      {isLoading && (
        <div className='ai-summary-loading'>
          <Spinner size='default' spinning indicator={<LoadingOutlined style={{ fontSize: 22 }} />} />
          <Text type='secondary' style={{ fontSize: 12 }}>
            Analysing deals, notes, emails and calls from HubSpot. This can take up to a minute…
          </Text>
        </div>
      )}
      {isError && !isLoading && (
        <div>
          <Text type='danger'>Unable to generate the summary right now. Please try again later.</Text>
          <Button type='link' size='small' onClick={() => refetch()}>Retry</Button>
        </div>
      )}
      {!isLoading && !isError && data && (
        <>
          <div className='ai-summary-text'>
            {data.summary
              ? renderExplanation(data.summary, ACCENT)
              : <Text type='secondary'>No HubSpot history to summarize for this author yet.</Text>}
          </div>
          <Text type='secondary' className='ai-summary-footer'>
            AI-generated from this author&apos;s HubSpot deals, notes, emails and calls, plus Brenda&apos;s title
            and sales data. Contact details and financial identifiers are removed before analysis.
          </Text>
        </>
      )}
    </AiSummaryBar>
  );
};

export default AuthorRelationshipSummary;
